import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_mof_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  gl_dimension_code: fromDatatype.VarcharDatatypeInterface;
  amount_cogs: fromDatatype.BigIntegerDatatypeClass;
  amount_discount: fromDatatype.BigIntegerDatatypeClass;
  amount_net: fromDatatype.BigIntegerDatatypeClass;
  amount_open_balance: fromDatatype.BigIntegerDatatypeClass;
  amount_signum: fromDatatype.BigIntegerDatatypeClass;
  amount_std: fromDatatype.BigIntegerDatatypeClass;
  amount_tax_gst: fromDatatype.BigIntegerDatatypeClass;
  amount_tax_wht: fromDatatype.BigIntegerDatatypeClass;
  amount_txn: fromDatatype.BigIntegerDatatypeClass;
  amount_json: fromDatatype.JsonDatatypeInterface;
  after_final_step_json: fromDatatype.JsonDatatypeInterface;
  base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_xrate: fromDatatype.BigIntegerDatatypeClass;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  discount_description: fromDatatype.VarcharDatatypeInterface;
  discount_detail_method: fromDatatype.VarcharDatatypeInterface;
  discount_detail_promo_code: fromDatatype.VarcharDatatypeInterface;
  discount_detail_value: fromDatatype.VarcharDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom_desc: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: boolean;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_history_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  multi_level_disc_json: fromDatatype.JsonDatatypeInterface;
  pic_entity_01: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03_name: fromDatatype.VarcharDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
  profit_center_code: fromDatatype.VarcharDatatypeInterface;
  project_code: fromDatatype.VarcharDatatypeInterface;
  qty_by_uom: fromDatatype.BigIntegerDatatypeClass;
  qty_open: fromDatatype.BigIntegerDatatypeClass;
  qty_reserve_adj: fromDatatype.BigIntegerDatatypeClass;
  quantity_base: fromDatatype.BigIntegerDatatypeClass;
  quantity_signum: fromDatatype.BigIntegerDatatypeClass;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
  segment_code: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  svc_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  svc_record_01: fromDatatype.VarcharDatatypeInterface;
  svc_record_02: fromDatatype.VarcharDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.BigIntegerDatatypeClass;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_industry_code: fromDatatype.VarcharDatatypeInterface;
  tax_tariff_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.BigIntegerDatatypeClass;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  unit_disc_by_uom: fromDatatype.BigIntegerDatatypeClass;
  unit_discount: fromDatatype.BigIntegerDatatypeClass;
  unit_discount_with_tax: fromDatatype.BigIntegerDatatypeClass;
  unit_price_by_uom: fromDatatype.BigIntegerDatatypeClass;
  unit_price_net: fromDatatype.BigIntegerDatatypeClass;
  unit_price_std: fromDatatype.BigIntegerDatatypeClass;
  unit_price_std_by_uom: fromDatatype.BigIntegerDatatypeClass;
  unit_price_std_by_uom_with_tax: fromDatatype.BigIntegerDatatypeClass;
  unit_price_std_with_tax: fromDatatype.BigIntegerDatatypeClass;
  unit_price_txn: fromDatatype.BigIntegerDatatypeClass;
  unit_price_txn_by_uom: fromDatatype.BigIntegerDatatypeClass;
  uom: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  uom_to_base_ratio: fromDatatype.BigIntegerDatatypeClass;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  mof_item_guid: fromDatatype.GuidDataFieldInterface;
  mof_item_code: fromDatatype.VarcharDatatypeInterface;
  mof_item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  mof_item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  mof_item_desc: fromDatatype.VarcharDatatypeInterface;
  mof_item_name: fromDatatype.VarcharDatatypeInterface;
  mof_item_property_json: fromDatatype.JsonDatatypeInterface;
  mof_item_reference_no: fromDatatype.VarcharDatatypeInterface;
  mof_item_remarks: fromDatatype.VarcharDatatypeInterface;
  mof_item_txn_type: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
}

export class bl_aat_mof_doc_line_RowClass implements bl_aat_mof_doc_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  guid_branch: fromDatatype.GuidDataFieldInterface;
  guid_comp: fromDatatype.GuidDataFieldInterface;
  guid_dimension: fromDatatype.GuidDataFieldInterface;
  guid_glcode: fromDatatype.GuidDataFieldInterface;
  guid_parent: fromDatatype.GuidDataFieldInterface;
  guid_profit_center: fromDatatype.GuidDataFieldInterface;
  guid_project: fromDatatype.GuidDataFieldInterface;
  guid_segment: fromDatatype.GuidDataFieldInterface;
  guid_store: fromDatatype.GuidDataFieldInterface;
  guid_store_2: fromDatatype.GuidDataFieldInterface;
  gl_dimension_code: fromDatatype.VarcharDatatypeInterface;
  amount_cogs: fromDatatype.BigIntegerDatatypeClass;
  amount_discount: fromDatatype.BigIntegerDatatypeClass;
  amount_net: fromDatatype.BigIntegerDatatypeClass;
  amount_open_balance: fromDatatype.BigIntegerDatatypeClass;
  amount_signum: fromDatatype.BigIntegerDatatypeClass;
  amount_std: fromDatatype.BigIntegerDatatypeClass;
  amount_tax_gst: fromDatatype.BigIntegerDatatypeClass;
  amount_tax_wht: fromDatatype.BigIntegerDatatypeClass;
  amount_txn: fromDatatype.BigIntegerDatatypeClass;
  amount_json: fromDatatype.JsonDatatypeInterface;
  after_final_step_json: fromDatatype.JsonDatatypeInterface;
  base_doc_line_ccy: fromDatatype.VarcharDatatypeInterface;
  base_doc_line_xrate: fromDatatype.BigIntegerDatatypeClass;
  base_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_period_guid: fromDatatype.GuidDataFieldInterface;
  budget_fiscal_year_guid: fromDatatype.GuidDataFieldInterface;
  budget_item_guid: fromDatatype.GuidDataFieldInterface;
  budget_register_guid: fromDatatype.GuidDataFieldInterface;
  discount_description: fromDatatype.VarcharDatatypeInterface;
  discount_detail_method: fromDatatype.VarcharDatatypeInterface;
  discount_detail_promo_code: fromDatatype.VarcharDatatypeInterface;
  discount_detail_value: fromDatatype.VarcharDatatypeInterface;
  display_option: fromDatatype.VarcharDatatypeInterface;
  date_txn: fromDatatype.TimestampTzDatatypeInterface;
  doc_ccy: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_code: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_desc: fromDatatype.VarcharDatatypeInterface;
  einvoice_taxable_type_guid: fromDatatype.GuidDataFieldInterface;
  einvoice_uom: fromDatatype.VarcharDatatypeInterface;
  einvoice_uom_desc: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_line_guid: fromDatatype.GuidDataFieldInterface;
  entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  entity_fi_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_inv_item_link_guid: fromDatatype.GuidDataFieldInterface;
  entity_json: fromDatatype.JsonDatatypeInterface;
  foreign_ccy: boolean;
  forex_source_hdr_guid: fromDatatype.GuidDataFieldInterface;
  forex_source_history_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  generic_doc_line_guid: fromDatatype.GuidDataFieldInterface;
  item_child_json: fromDatatype.JsonDatatypeInterface;
  item_code: fromDatatype.VarcharDatatypeInterface;
  item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  item_desc: fromDatatype.VarcharDatatypeInterface;
  item_guid: fromDatatype.GuidDataFieldInterface;
  item_machine_code: fromDatatype.VarcharDatatypeInterface;
  item_name: fromDatatype.VarcharDatatypeInterface;
  item_property_json: fromDatatype.JsonDatatypeInterface;
  item_reference_no: fromDatatype.VarcharDatatypeInterface;
  item_remarks: fromDatatype.VarcharDatatypeInterface;
  item_sub_type: fromDatatype.VarcharDatatypeInterface;
  item_to_item_link_json: fromDatatype.JsonDatatypeInterface;
  item_txn_type: fromDatatype.VarcharDatatypeInterface;
  label_json: fromDatatype.JsonDatatypeInterface;
  multi_level_disc_json: fromDatatype.JsonDatatypeInterface;
  pic_entity_01: fromDatatype.VarcharDatatypeInterface;
  pic_entity_01_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02: fromDatatype.VarcharDatatypeInterface;
  pic_entity_02_name: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03: fromDatatype.VarcharDatatypeInterface;
  pic_entity_03_name: fromDatatype.VarcharDatatypeInterface;
  position_id: fromDatatype.VarcharDatatypeInterface;
  pricing_scheme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  pricing_scheme_link_guid: fromDatatype.GuidDataFieldInterface;
  profit_center_code: fromDatatype.VarcharDatatypeInterface;
  project_code: fromDatatype.VarcharDatatypeInterface;
  qty_by_uom: fromDatatype.BigIntegerDatatypeClass;
  qty_open: fromDatatype.BigIntegerDatatypeClass;
  qty_reserve_adj: fromDatatype.BigIntegerDatatypeClass;
  quantity_base: fromDatatype.BigIntegerDatatypeClass;
  quantity_signum: fromDatatype.BigIntegerDatatypeClass;
  reference_no: fromDatatype.VarcharDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  sales_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  sales_entity_hdr_name: fromDatatype.VarcharDatatypeInterface;
  segment_code: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  sort_code: fromDatatype.VarcharDatatypeInterface;
  svc_issue_hdr_guid: fromDatatype.GuidDataFieldInterface;
  svc_record_01: fromDatatype.VarcharDatatypeInterface;
  svc_record_02: fromDatatype.VarcharDatatypeInterface;
  tax_gst_code: fromDatatype.VarcharDatatypeInterface;
  tax_gst_rate: fromDatatype.BigIntegerDatatypeClass;
  tax_gst_type: fromDatatype.VarcharDatatypeInterface;
  tax_industry_code: fromDatatype.VarcharDatatypeInterface;
  tax_tariff_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_code: fromDatatype.VarcharDatatypeInterface;
  tax_wht_rate: fromDatatype.BigIntegerDatatypeClass;
  tax_wht_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  unit_disc_by_uom: fromDatatype.BigIntegerDatatypeClass;
  unit_discount: fromDatatype.BigIntegerDatatypeClass;
  unit_discount_with_tax: fromDatatype.BigIntegerDatatypeClass;
  unit_price_by_uom: fromDatatype.BigIntegerDatatypeClass;
  unit_price_net: fromDatatype.BigIntegerDatatypeClass;
  unit_price_std: fromDatatype.BigIntegerDatatypeClass;
  unit_price_std_by_uom: fromDatatype.BigIntegerDatatypeClass;
  unit_price_std_by_uom_with_tax: fromDatatype.BigIntegerDatatypeClass;
  unit_price_std_with_tax: fromDatatype.BigIntegerDatatypeClass;
  unit_price_txn: fromDatatype.BigIntegerDatatypeClass;
  unit_price_txn_by_uom: fromDatatype.BigIntegerDatatypeClass;
  uom: fromDatatype.VarcharDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  uom_to_base_ratio: fromDatatype.BigIntegerDatatypeClass;
  votebook_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  mof_item_guid: fromDatatype.GuidDataFieldInterface;
  mof_item_code: fromDatatype.VarcharDatatypeInterface;
  mof_item_custom_data_json: fromDatatype.JsonDatatypeInterface;
  mof_item_custom_template_json: fromDatatype.JsonDatatypeInterface;
  mof_item_desc: fromDatatype.VarcharDatatypeInterface;
  mof_item_name: fromDatatype.VarcharDatatypeInterface;
  mof_item_property_json: fromDatatype.JsonDatatypeInterface;
  mof_item_reference_no: fromDatatype.VarcharDatatypeInterface;
  mof_item_remarks: fromDatatype.VarcharDatatypeInterface;
  mof_item_txn_type: fromDatatype.VarcharDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_name: fromDatatype.VarcharDatatypeInterface;
  updated_by_name: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
}
